import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import { Button, Tooltip } from 'antd';

function sheetOf(rows, headers) {
    if (rows && rows.length) return XLSX.utils.json_to_sheet(rows);
    return XLSX.utils.aoa_to_sheet([headers || []]);
}

export default function ExportExcel({ excelData, fileName, sheets = null }) {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const exportToExcel = async fileName => {
        const book = sheets && sheets.length ? sheets : [{ name: 'data', rows: excelData || [] }];
        const Sheets = {};
        const SheetNames = [];
        book.forEach(sheet => {
            const name = String(sheet.name || 'data').slice(0, 31);
            Sheets[name] = sheetOf(sheet.rows, sheet.headers);
            SheetNames.push(name);
        });
        const excelBuffer = XLSX.write({ Sheets, SheetNames }, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(blob, fileName + fileExtension);
    };

    return (
        <>
            <Tooltip>
                <Button
                    type="primary"
                    onClick={() => exportToExcel(fileName)}
                    style={{
                        marginRight: '10px',
                    }}
                >
                    Export Excel
                </Button>
            </Tooltip>
        </>
    );
}
